<template>
  <span :class="countdownColour">
    {{ mixin_time | countdownshortformat }}
  </span>
</template>

<script>
import TimerMixin from "@/mixins/TimerMixin";

export default {
  props: {
    startTime: {
      type: Number,
      default: 0,
    },
    priceQuoteId: {
      type: String,
      default: "",
    },
  },
  mixins: [TimerMixin],
  created() {
    this.mixin_startTimer(this.startTime);
  },
  computed: {
    countdownColour: function () {
      if (this.mixin_time < 60) {
        return "text-t_red";
      }
      return "text-t_green";
    },
  },
  watch: {
    mixin_time: function () {
      if (this.mixin_time <= 1) {
        this.$emit("set-to-expired", this.priceQuoteId);
      }
    },
  },
  beforeDestroy() {
    this.mixin_stopTimer();
  }
};
</script>
<style lang="scss" scoped>

</style>
